<div class="chart-container">
    <canvas #canvas class="{{chart.config.type}}"></canvas>

    <section class="stacks-labels" *ngIf="stacksLabels.length">
        <p>{{ 'reports.barChart.stacksTitle.default.summary' | translate }} :</p>
        <ul>
            <li *ngFor="let label of stacksLabels"> {{label}}</li>
        </ul>
    </section>
</div>
